import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New design variables introduced 11-12-2019 */

    /* New design variables introduced 7-16-2020 */
}
:root {
    @lost gutter 24px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    @custom-media --small-up (min-width: 322px);
    @custom-media --small-down (max-width: 320px);
    @custom-media --small-only (max-width: 320px);

    @custom-media --medium-up (min-width: 722px);
    @custom-media --medium-down (max-width: 720px);
    @custom-media --medium-only (max-width: 720px) and (min-width: 321.001);

    @custom-media --large-up (min-width: 1082px);
    @custom-media --large-down (max-width: 1080px);
    @custom-media --large-only (max-width: 1080px) and (min-width: 721.001);

    @custom-media --xlarge-up (min-width: 1442px);
    @custom-media --xlarge-down (max-width: 1440px);
    @custom-media --xlarge-only (max-width: 1440px) and (min-width: 1081.001);

    @custom-media --xxlarge-up (min-width: 1922px);
    @custom-media --xxlarge-down (max-width: 1920px);
    @custom-media --xxlarge-only (max-width: 1920px) and (min-width: 1441.001);

    @custom-media --small-up-height (min-height: 322px);
    @custom-media --small-down-height (max-height: 320px);
    @custom-media --small-only-height (max-height: 320px);

    @custom-media --medium-up-height (min-height: 722px);
    @custom-media --medium-down-height (max-height: 720px);
    @custom-media --medium-only-height (max-height: 720px) and (min-height: 321.001);

    @custom-media --large-up-height (min-height: 1082px);
    @custom-media --large-down-height (max-height: 1080px);
    @custom-media --large-only-height (max-height: 1080px) and (min-height: 721.001);

    @custom-media --xlarge-up-height (min-height: 1442px);
    @custom-media --xlarge-down-height (max-height: 1440px);
    @custom-media --xlarge-only-height (max-height: 1440px) and (min-height: 1081.001);

    @custom-media --xxlarge-up-height (min-height: 1922px);
    @custom-media --xxlarge-down-height (max-height: 1920px);
    @custom-media --xxlarge-only-height (max-height: 1920px) and (min-height: 1441.001);
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
button {
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
/**
 * Do not edit directly
 * Generated on Thu, 18 Nov 2021 20:00:26 GMT
 */
@media screen and (prefers-reduced-motion: reduce) {
.trp-toggle-switch-slider{
  background-color:rgba(249, 250, 250, 1);
  border:rgba(211, 215, 218, 1) solid 1px;
  border-radius:26px;
  height:26px;
  position:absolute;
  transition:none;
  width:54px;
  box-sizing: content-box;
}
}
.trp-toggle-switch-slider{
  background-color:rgba(249, 250, 250, 1);
  border:rgba(211, 215, 218, 1) solid 1px;
  border-radius:26px;
  height:26px;
  position:absolute;
  transition:.25s;
  width:54px;
  box-sizing: content-box
}
@media screen and (prefers-reduced-motion: reduce) {
.trp-toggle-switch-slider::after{
  background-color:rgba(255, 255, 255, 1);
  border-radius:50%;
  bottom:2px;
  box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.08), 2px 3px 7px 0 rgba(0, 0, 0, 0.16);
  content:"";
  height:22px;
  left:2px;
  position:absolute;
  transition:none;
  width:22px;
}
}
.trp-toggle-switch-slider::after{
  background-color:rgba(255, 255, 255, 1);
  border-radius:50%;
  bottom:2px;
  box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.08), 2px 3px 7px 0 rgba(0, 0, 0, 0.16);
  content:"";
  height:22px;
  left:2px;
  position:absolute;
  transition:.25s;
  width:22px
}
.trp-toggle-switch-label{
  cursor:pointer;
  display:flex;
  flex-wrap:wrap;
  width:100%
}
.trp-toggle-switch-input{
  visibility:hidden
}
.trp-toggle-switch-input:checked+.trp-toggle-switch-label .trp-toggle-switch-slider::after{
  left:30px
}
.trp-toggle-switch-slider-text{
  align-items:center;
  color:rgba(146, 155, 163, 1);
  display:flex;
  font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  height:25px;
  left:29px;
  letter-spacing:0.0012em;
  line-height:1.60em;
  position:absolute;
  top:calc(50% - 25px / 2 + .5px);
  width:17px
}
.trp-toggle-switch-slider-text.trp-toggle-switch-slider-text-on{
  color:rgba(255, 255, 255, 1);
  left:9px;
  width:18px
}
.trp-toggle-switch-slider-icon{
  left:29px;
  position:absolute;
  top:5px
}
.trp-toggle-switch-slider-icon.trp-toggle-switch-slider-icon-on{
  left:9px
}
.trp-toggle-switch-input:disabled~.trp-toggle-switch-label{
  cursor:default
}
.trp-toggle-switch-input:disabled~.trp-toggle-switch-label .trp-toggle-switch-slider::after{
  background-color:rgba(211, 215, 218, 1);
  box-shadow:none
}
.trp-toggle-switch-input:disabled~.trp-toggle-switch-label .trp-toggle-switch-slider .trp-toggle-switch-slider-text{
  color:rgba(211, 215, 218, 1)
}
.trp-toggle-switch-input:disabled~.trp-toggle-switch-label .trp-toggle-switch-slider .trp-toggle-switch-slider-text.trp-toggle-switch-slider-text-on{
  color:rgba(255, 255, 255, 1)
}
.trp-toggle-switch-lt .trp-toggle-switch-input:checked~label .trp-toggle-switch-slider{
  background-color:rgba(8, 110, 161, 1);
  border:rgba(8, 110, 161, 1) solid 1px
}
.trp-toggle-switch-dt .trp-toggle-switch-input:checked~label .trp-toggle-switch-slider{
  background-color:rgba(0, 125, 179, 1);
  border:rgba(0, 125, 179, 1) solid 1px
}
.trp-toggle-switch-input:checked:disabled~.trp-toggle-switch-label .trp-toggle-switch-slider{
  background-color:rgba(211, 215, 218, 1);
  border:rgba(211, 215, 218, 1) solid 1px
}
.trp-toggle-switch-input:checked:disabled~.trp-toggle-switch-label .trp-toggle-switch-slider::after{
  background-color:rgba(255, 255, 255, 1);
  box-shadow:none
}
.trp-toggle-switch-icon {
  height:16px;
  width:16px;
}


`;

export default styles;